import { useEffect, useState, useRef } from "react";
import { Link } from "react-router-dom";
import { DataTable } from "primereact/datatable";
import useUserStore from "../../../utils/storeApp";
import CallAPI from "../../../services/apiCalls";
import { Column } from "primereact/column";
import $ from "jquery";
import { Tag } from "primereact/tag";
import { useReactToPrint } from "react-to-print";
import { CSVLink } from "react-csv";
import SharedMsg from "../SharedMsg";

const ListMessageSent = () => {
  const { userRole, userToken, sharedObject, SetSharedObject } = useUserStore(
    (state) => ({
      userRole: state.userRole,
      userToken: state.userToken,
      sharedObject: state.sharedObject,
      SetSharedObject: state.SetSharedObject,
    })
  );
  const [userObj, setUserObj] = useState([]);
  const [count, setCount] = useState(0);
  const [processing, SetProcessing] = useState(false);
  const firstFocusRef = useRef(null);

  useEffect(() => {
    const modalEl = document.getElementById("FlReportModal");
    if (!modalEl) return;
    const onShown = () => setTimeout(() => firstFocusRef.current?.focus(), 50);
    modalEl.addEventListener("shown.bs.modal", onShown);
    return () => modalEl.removeEventListener("shown.bs.modal", onShown);
  }, []);


  useEffect(() => {
    let obj = sharedObject.sentMessageStatusResults;
    if (obj && Object.keys(obj).length > 0) {
      gridData(obj);
    }
  }, [sharedObject.sentMessageStatusResults]);
  const getReport = async (src, pg) => {
    SetProcessing(true);
    let call =
      "/reports/GetMessageStatus?sortBy=DateSent&sortDir=DESC&type=sent&page=" +
      pg;
    const res = await CallAPI(call, src, "post", userToken);
    await SetSharedObject("ResponseCode", res.code);
    if (res.status === "SUCCESS") {
      gridData(res.data.data);
      SetProcessing(false);
    } else if (res.status === "SERVERERROR") {
      SetProcessing(false);
    }
    SetProcessing(false);
  };
  const gridData = (obj) => {
    let cnt = obj.count;
    setCount(cnt);
    let tempObj = [];
    for (const row of obj.pageItems) {
      row.MDN = row.isMDN ? "MDN" : "Not MDN";
      row.dateSent = row.dateSent
        ? new Date(row.dateSent).toLocaleString("en-US", { hour12: false })
        : "";
      row.dateAccepted = row.dateAccepted
        ? new Date(row.dateAccepted).toLocaleString("en-US", { hour12: false })
        : "";
      row.dateConfirmed = row.dateConfirmed
        ? new Date(row.dateConfirmed).toLocaleString("en-US", { hour12: false })
        : "";
      row.statusCsv = row.status;
      tempObj.push(row);
    }
    setUserObj(tempObj);
  };
  const headers = [
    { label: "Sent Date", key: "dateSent" },
    { label: "Sent From", key: "fromAddress" },
    { label: "Sent To", key: "sentAddress" },
    { label: "Message Type", key: "MDN" },
    { label: "Status", key: "statusCsv" },
    { label: "Date Time Accepted", key: "dateAccepted" },
    { label: "Date Time Confirmed", key: "dateConfirmed" },
    { label: "Organization", key: "organizationName" },
  ];
  const getSeverity = (product) => {
    switch (product.status) {
      case "Confirmed":
        return "success";
      case "Success":
        return "success";
      case "Accepted":
        return "success";
      case "Failed":
        return "danger";

      default:
        return null;
    }
  };
  const sentMessageTemplate = (product) => {
    let s =
      product.status === "Failed" ? (
        <button
          type="button"
          className="btn btn-link sp-pad0 font-weight-bold"
          aria-label={`View troubleshooting for failed message`}
          onClick={(el) => {
            openStatus(product);
            el.preventDefault();
          }}
        >
          <Tag value={product.status} severity={getSeverity(product)}></Tag>
        </button>
      ) : (
        <Tag value={product.status} severity={getSeverity(product)}></Tag>
      );

    return s;
  };
  const [extendedStatus, setExtendedStatus] = useState(false);
  const openStatus = (obj) => {
    setExtendedStatus(obj.extendedStatus);
    $("#FlReportModal").modal("show");
  };

  const componentRef = useRef();
  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
  });
  const refreshPage = () => {
    getReport(sharedObject.messageStatusSearch, 1);
  };
  const bulkDownLoad = (val) => {
    SetSharedObject("SentSearchType", val);
    $("#sentMsgSearchModal").modal("show");
  };

  const [loadingText, setLoadingText] = useState("Loading...");
  useEffect(() => {
    let timer;
    if (processing) {
      timer = setTimeout(() => {
        setLoadingText("Working on it...");
      }, 10000);
    } else {
      setLoadingText("Loading...");
    }

    return () => clearTimeout(timer);
  }, [processing]);

  const CloseModal = () => {
    if (document.activeElement instanceof HTMLElement) {
      document.activeElement.blur();
    }
      
    $("#FlReportModal").modal("hide");
  };

  return (
    <main ref={componentRef} className="ListMessageSent">
      <header>
          <div className="spacer-inline sp-margin12">
            <h4 className="title-label3">Sent Message</h4>
          </div>
          <div className="mid-header-bar spacer-inline sp-mx5">
            <button
              className="btn btn-outline-dark sp-margin5 btn-reports-sm"
              data-toggle="modal"
              aria-label="Open sent message search"
              aria-haspopup="dialog"
              onClick={(e) => {
                bulkDownLoad("reg");
              }}
            >
              <i className="bi bi-search" aria-hidden="true"></i>
            </button>

            <button
              type="button"
              className="btn btn-outline-dark sp-margin5 btn-reports-sm"
              data-toggle="modal"
              aria-label="Bulk download sent messages"
              aria-haspopup="dialog"
              onClick={(e) => {
                bulkDownLoad("bulk");
              }}
            >
              <i className="bi bi-box-arrow-down" aria-hidden="true"></i>
            </button>

            {/*Reusable tools for reports*/}
            <div className="spacer-inline" role="toolbar" aria-label="Sent message report export and refresh tools">
                <span className="SharedTools" role="group" aria-label="Export and print tools">
                    {count > 0 ? (
                      <CSVLink
                        filename="SentMessageReport.csv"
                        className="btn btn-outline-dark sp-margin5 btn-reports-sm"
                        data={userObj}
                        headers={headers}
                        aria-label="Download sent messages as MS Excel CSV file"
                      >
                            <i className="bi bi-download" aria-hidden="true"></i>
                      </CSVLink>
                    ) : (
                        <button
                            type="button"
                            className="btn btn-outline-dark sp-margin5 btn-reports-sm"
                            disabled
                            aria-disabled="true"
                            aria-label="Download CSV (no results available)"
                        >
                          <i className="bi bi-download" aria-hidden="true"></i>
                      </button>
                    )}
                  
                  <button
                    type="button"
                    className="btn btn-outline-dark sp-margin5 btn-reports-sm"
                    disabled={count === 0} 
                    aria-disabled={count === 0}
                    aria-label={
                          count === 0
                            ? "Refresh report (no results to refresh)"
                            : "Refresh report"
                        }
                    onClick={(e) => {
                      if (count > 0) refreshPage();
                    }}
                  >
                    <i className="bi bi-arrow-clockwise" aria-hidden="true"></i>
                  </button>
                  <button
                    type="button"
                    className="btn btn-outline-dark sp-margin5 btn-reports-sm"
                    aria-label={
                      count === 0
                        ? "Print report (no results to print)"
                        : "Print received messages report"
                    }
                    disabled={count === 0} 
                    aria-disabled={count === 0}
                    onClick={(e) => {
                      if (count > 0) handlePrint();
                    }}
                  >
                    <i className="bi bi-printer" aria-hidden="true"></i>
                  </button>
                </span>
            </div>
            <button
              className="btn btn-outline-dark sp-margin5 btn-reports-sm"
              type="button"
              data-target="#MsgGuideModal"
              data-toggle="modal"
              aria-label="Open message status guide"
              aria-haspopup="dialog"
            >
              <i className="bi bi-chat-square-text" aria-hidden="true"></i>
            </button>
          </div>
      </header>

      <div>
        <section className="grid-header-bar" aria-label="Report filter summary">
          {userRole !== "SES ADMINISTRATOR" &&
          userRole !== "SYSTEMADMINISTRATOR" ? null : (
            <>
              <dl className="sp-mx7">
                  <div className="spacer-inline spacer-margin1">
                    <dt className="ft-wt">Domain:</dt>
                    <dd className="sp-margin12 sp-mx7">
                      {sharedObject.messageStatusSearch.DomainName
                        ? sharedObject.messageStatusSearch.DomainName
                        : null}
                    </dd>
                  </div>
                  <div className="spacer-inline">
                    <dt className="ft-wt">Customer:</dt>
                    <dd className="sp-margin12 sp-mx7">
                      {sharedObject.messageStatusSearch.VendorName
                        ? sharedObject.messageStatusSearch.VendorName
                        : null}
                    </dd>
                  </div>
              </dl>
            </>
          )}
          <SharedMsg />
        </section>
        <section className="grid-layout">
          {userObj?.length > 0 ? (
            <div id="SentMessageReport">
              <DataTable
                value={userObj}
                aria-label="Sent messages"
                paginator
                selectionPageOnly
                rows={25}
                rowsPerPageOptions={[25, 50, 75]}
                tableStyle={{ minWidth: "50rem" }}
                paginatorTemplate="RowsPerPageDropdown FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink"
                currentPageReportTemplate="{first} to {last} of {totalRecords}"
                dataKey="Id"
                columnResizeMode="expand"
                resizableColumns
                scrollable
                sortField="dateSent"
                sortOrder={-1}
              >
                <Column field="dateSent" header="Sent Date" className="w-md8" sortable ></Column>
                <Column field="fromAddress" header="Sent From" className="truncate" sortable ></Column>
                <Column field="sentAddress" header="Sent To" className="truncate" sortable ></Column>
                <Column field="MDN" header="Message Type" className="w-md9" sortable ></Column>
                <Column field="status" header="Status" body={sentMessageTemplate} className="w-md4" sortable ></Column>
                <Column field="dateAccepted" header="Date Time Accepted" className="w-md8" sortable ></Column>
                <Column field="dateConfirmed" header="Date Time Confirmed" className="w-md7" sortable ></Column>
                <Column field="organizationName" header="Organization" className="print-col" sortable ></Column>
              </DataTable>
            </div>
          ) : (
            <div 
                className="empty-grid"
                role="status"
                aria-live="polite"
                aria-atomic="true"
             >
              There are currently no search results.
            </div>
          )}
        </section>

        {/* Failed Report Modal*/}
        <div
          className="modal fade"
          id="FlReportModal"
          tabIndex="-1"
          role="dialog"
          aria-labelledby="failed-report-status-title"
          aria-describedby="failedReportStatusModalDesc"
          data-backdrop="static"
        >
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header">
                <h2 className="modal-title spacer-inline" id="failed-report-status-title">
                  Troubleshooting
                </h2>
                <button
                  type="button"
                  className="close"
                  aria-label="Close failed report extended status modal"
                  onClick={CloseModal}
                >
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div className="modal-body">
                   <div className="modal-content-body" id="failedReportStatusModalDesc">{extendedStatus}.</div>
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-outline-secondary"
                  onClick={CloseModal}
                >
                  Close
                </button>
              </div>
            </div>
          </div>
        </div>


        {processing && (
              <div 
                className="loader-container" 
                role="status" 
                aria-live="polite" 
                aria-atomic="true"
                aria-labelledby="list-sentmessage-loader"
            >
                <div className="spinner" aria-hidden="true"></div>
                <div className="loading-text" id="list-sentmessage-loader">{loadingText}</div>
            </div>
        )}
      </div>
    </main>
  );
};

export default ListMessageSent;
